<div class="w-full drop-shadow-lg">
  <img [class.focus]="active && isFocused"
       [ngSrc]="video.thumbnailUrl ?? ''"
       height="360"
       priority
       width="640" />
</div>
<span class="title">{{ video.title }}</span>
<span class="description">{{ video.caption }}</span>
